import React from 'react';
import { Container, Box } from '@mui/material';
import { PageTitleSkeleton } from 'views/common/components';
import { ReviewsSectionsSkeleton } from 'views/tours-module/TourReviewsView/components';

const TourReviewsViewSkeleton = () => (
  <Container maxWidth="xl">
    <PageTitleSkeleton />
    <Box mt={3}>
      <ReviewsSectionsSkeleton />
    </Box>
  </Container>
);
export { TourReviewsViewSkeleton };
